const items = {
  "group": "群组",
  "group.fields.name.label": "群组名",
  "group.files": "群文档",
  "group.member": "群成员",
};

export default items;
